import React from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faCreditCard, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import "./style.css";

const stepRoutes = [
  "/orderdomain",
  "/orderhosting",
  "/orderserver",
  "/orderproduct",
  "/orderdomainbackorder",
  "/migrasihosting"
];

const ProgressBar = () => {
  const location = useLocation();
  let currentStep = 1;

  if (stepRoutes.includes(location.pathname)) {
    currentStep = 1;
  } else if (location.pathname === "/paymentmethod") {
    currentStep = 2;
  } else if (location.pathname === "/ordersummary") {
    currentStep = 3;
  }
  
  return (
    <div className="order-progressbar-wrapper">
      <div className="d-flex justify-content-between">
        <div className="progress-label-item text-center">
          <span className={`progress-label-text ${currentStep >= 1 ? "fw-bold text-dark" : ""}`}>
            <FontAwesomeIcon icon={faShoppingCart} />
            Pilih Produk
          </span>
        </div>
        <div className="progress-label-item text-center">
          <span className={`progress-label-text ${currentStep >= 2 ? "fw-bold text-dark" : ""}`}>
            <FontAwesomeIcon icon={faCreditCard} />
            Pilih Metode Pembayaran
          </span>
        </div>
        <div className="progress-label-item text-center">
          <span className={`progress-label-text ${currentStep >= 3 ? "fw-bold text-dark" : ""}`}>
            <FontAwesomeIcon icon={faCheckCircle} />
            Selesai
          </span>
        </div>
      </div>
      <div className="order-progressbar-steps">
        <div className={`progress-step ${currentStep >= 1 ? "active" : ""} ${currentStep > 1 ? "done" : ""}`}>
          {currentStep > 1 ? <FontAwesomeIcon icon={faCheckCircle} /> : "1"}
        </div>
        <div className={`progress-line ${currentStep >= 2 ? "active" : ""}`}></div>
        <div className={`progress-step ${currentStep >= 2 ? "active" : ""} ${currentStep > 2 ? "done" : ""}`}>
          {currentStep > 2 ? <FontAwesomeIcon icon={faCheckCircle} /> : "2"}
        </div>
        <div className={`progress-line ${currentStep >= 3 ? "active" : ""}`}></div>
        <div className={`progress-step ${currentStep >= 3 ? "active" : ""}`}>
          {currentStep >= 3 ? <FontAwesomeIcon icon={faCheckCircle} /> : "3"}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
